'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const CONTACT_EMAIL = 'info@reprintsolution.online';
const LAST_UPDATED = '1 June 2026';

export default function PurchasePolicyPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-4xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Purchase Policy</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Purchase Policy</h1>
            <p className="mt-3 text-slate-400 text-sm">Last updated: {LAST_UPDATED}</p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-4xl px-4">
            <div className="space-y-8 text-sm leading-7 text-slate-300">

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Order Placement</h2>
                <p className="mt-3">
                  By placing an order on RePrint Solution, you confirm that you are at least 18 years of age and that all information provided is accurate and complete. We reserve the right to refuse or cancel any order at our discretion.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Order Confirmation</h2>
                <p className="mt-3">
                  After placing an order, you will receive an order confirmation email. This email confirms that we have received your order. It does not constitute acceptance of your order. We reserve the right to cancel orders if products are unavailable or if pricing errors occur.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Payment</h2>
                <p className="mt-3">
                  We accept major credit and debit cards. All payments are processed securely. We do not store your full payment card details on our servers. Prices are displayed in GBP (£) and include applicable taxes unless otherwise stated.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Product Availability</h2>
                <p className="mt-3">
                  All products are subject to availability. As refurbished items are often one-of-a-kind, stock levels can change rapidly. If an item becomes unavailable after your order is placed, we will notify you promptly and offer a full refund or suitable alternative.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Pricing</h2>
                <p className="mt-3">
                  We make every effort to ensure prices are accurate. In the event of a pricing error, we reserve the right to cancel the order and notify you. You will not be charged for cancelled orders.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Cancellations</h2>
                <p className="mt-3">
                  You may cancel your order within <strong className="text-white">24 hours</strong> of placing it, provided it has not yet been dispatched. To cancel, contact us immediately at <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>. Once dispatched, our standard return policy applies.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Warranty</h2>
                <p className="mt-3">
                  Warranty terms vary by product and are stated on individual product listings. Warranty covers manufacturing defects and functional failures under normal use. It does not cover damage caused by misuse, accidents, or unauthorised modifications.
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                <h2 className="text-lg font-black text-white">Contact Us</h2>
                <p className="mt-3">
                  For purchase-related enquiries, contact us at:{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`} className="text-violet-400 hover:text-violet-300 underline">{CONTACT_EMAIL}</a>
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
